import {NgModule} from "@angular/core";
import {MomentPipe} from "./moment.pipe";
import {TimeDirective} from "./time.directive";
import { FieldFilterPipe } from './field-filter.pipe';
import {BodyService} from "./body.service";
import {NotificationService} from "./notification.service";
import {ToggleActiveDirective} from "./toggle-active.directive";
import {RemoveQuotesPipe} from "./remove-quotes.pipe"
import {FilterPipe} from "./filter-pipe";
import {KeysPipe} from "./keys-pipe";
import {SortPipe} from "./sortBy-pipe";

@NgModule({
  declarations: [ToggleActiveDirective, MomentPipe, TimeDirective, FieldFilterPipe, RemoveQuotesPipe, KeysPipe, SortPipe],
  exports: [ToggleActiveDirective, MomentPipe, TimeDirective, FieldFilterPipe, RemoveQuotesPipe, KeysPipe, SortPipe],
  providers: [BodyService, NotificationService]
})
export class UtilsModule{
  static forRoot(){
    return {
      ngModule: UtilsModule,
      providers: [BodyService, NotificationService]
    }
  }
}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/utils/utils.module.ts